// extracted by mini-css-extract-plugin
export default {"container":"second-screen_container__lZdB1","content":"second-screen_content__PzAsK","image":"second-screen_image__lmaoJ","title":"second-screen_title__6GET0"};